/**
 * call integration
 */
import customerStore from '@/store/modules/customer/index.js'
import uuidV4 from 'liquor-tree/src/utils/uuidV4'

const getDefaultState = () => {
  return {
    callAgentStatus: '',
    callAgentStatusStartTime: '',
    btnStatus: {
      login: false, // 로그인
      logOut: false, // 로그아웃
      makeCall: false, // 걸기
      answer: false, // 받기
      hold: false, // 보류
      retrieve: false, // 재통화
      consult: false, // 협의
      transfer: false, // 전환
      conference: false, // 회의
      reconnect: false, // 전환 취소
      notReady: false, // 대기 외 다른 상태
      ready: false, // 대기
      disconnect: false, // 끊기
      reserve: false, // 예약
      sendMessage: false // 문자발송
    },
    callInfo: {
      brandDnis: '',
      callbackId: '',
      callbackType: '',
      callEvent: '',
      contactTypeId: '',
      userKey: '',
      recordNo: '',
      dnis: '',
      startTime: '',
      endTime: '',
      serviceCode: '',
      incomingChannel: '',
      taskData: {},
      tagList: [],
      memo: '',
      isClose: false,
      isAgentClose: false,
      isSummaryCompleted: true,
      ticketId: null,
      ticketStatus: '',
      isOriginatedEnd: false,
      isCleared: false,
      isAnonymous: false,
      isCallEnd: false
    },
    channelUniqueKey: false,
    isTransferCancel: false
  }
}

const state = getDefaultState()

const getters = {
  callAgentStatus: (state) => { return state.callAgentStatus },
  btnStatus: (state) => { return state.btnStatus },
  callInfo: (state) => { return state.callInfo },
  isSummaryCompleted: (state) => { return state.callInfo.isSummaryCompleted },
  callUserKey: (state) => { return state.callInfo.userKey },
  callAgentStatusStartTime: (state) => { return state.callAgentStatusStartTime },
  isAnonymous: (state) => { return state.isAnonymous },
  channelUniqueKey: (state) => { return state.channelUniqueKey },
  isTransferCancel: (state) => { return state.isTransferCancel }
}

const actions = {
  initCallAgentStatus (context) {
    context.commit('initCallAgentStatus')
  },
  initBtnStatus (context) {
    context.commit('initBtnStatus')
  },
  initCallInfo (context) {
    context.commit('initCallInfo')
  },
  initLocalStorage (context) {
    context.commit('initCallAgentStatus')
    context.commit('initBtnStatus')
    context.commit('initCallInfo')
    localStorage.setItem('call-info', JSON.stringify(state.callInfo))
    localStorage.setItem('btn-status', JSON.stringify(state.btnStatus))

    const data = JSON.parse(localStorage.getItem('call-agent-status'))
    if (!(data && data.status && data.status === state.callAgentStatus)) {
      localStorage.setItem('call-agent-status', JSON.stringify({
        status: state.callAgentStatus,
        time: new Date().getTime()
      }))
    }
  },
  changeCallUserKey (context, payload) {
    customerStore.mutations.changeCustomerPhoneNumber(customerStore.state, payload)
    context.commit('changeCallUserKey', payload)
  }
}

const mutations = {
  initCallAgentStatus (state) {
    const data = JSON.parse(localStorage.getItem('call-agent-status'))
    if (data) {
      state.callAgentStatus = data.status
      state.callAgentStatusStartTime = data.time
    } else {
      state.callAgentStatus = ''
      state.callAgentStatusStartTime = ''
    }
  },
  initBtnStatus (state) {
    const data = JSON.parse(localStorage.getItem('btn-status'))
    state.btnStatus = data || {
      login: false, // 로그인
      logOut: false, // 로그아웃
      makeCall: false, // 걸기
      answer: false, // 받기
      hold: false, // 보류
      retrieve: false, // 재통화
      consult: false, // 협의
      transfer: false, // 전환
      conference: false, // 회의
      reconnect: false, // 전환 취소
      notReady: false, // 대기 외 다른 상태d
      ready: false, // 대기
      disconnect: false, // 끊기
      reserve: false, // 예약
      sendMessage: false // 문자발송
    }
  },
  initCallInfo (state) {
    const data = JSON.parse(localStorage.getItem('call-info'))
    state.callInfo = data || {
      brandDnis: '',
      callbackId: '',
      callbackType: '',
      callEvent: '',
      contactTypeId: '',
      direction: '',
      dnis: '',
      endTime: '',
      incomingChannel: '',
      isAgentClose: false,
      isAnonymous: false,
      isCallEnd: false,
      isCleared: false,
      isClose: false,
      isOriginatedEnd: false,
      isSummaryCompleted: true,
      memo: '',
      recordNo: '',
      serviceCode: '',
      startTime: '',
      tagList: [],
      taskData: {},
      ticketId: null,
      ticketStatus: '',
      userKey: ''
    }
  },
  clearCallInfo (state) {
    state.callInfo = {
      brandDnis: '',
      callEvent: '',
      userKey: '',
      recordNo: '',
      direction: '',
      dnis: '',
      startTime: '',
      endTime: '',
      serviceCode: '',
      incomingChannel: '',
      taskData: {},
      contactTypeId: '',
      tagList: [],
      memo: '',
      isClose: false,
      isAgentClose: false,
      isSummaryCompleted: true,
      ticketId: null,
      ticketStatus: '',
      callbackId: '',
      callbackType: '',
      isOriginatedEnd: false,
      isCleared: false,
      isAnonymous: false,
      isCallEnd: false
    }
  },
  changeCallAgentStatus (state, payload) {
    const data = localStorage.getItem('call-agent-status')
    if (!(data && JSON.parse(data).status === payload)) {
      const callAgentStatusData = {
        status: payload,
        time: new Date().getTime()
      }
      state.callAgentStatus = callAgentStatusData.status
      state.callAgentStatusStartTime = callAgentStatusData.time
      // localStorage.setItem('call-agent-status', payload)
      localStorage.setItem('call-agent-status', JSON.stringify(callAgentStatusData))
    }
  },
  changeBtnStatus (state, payload) {
    state.btnStatus = payload
    localStorage.setItem('btn-status', JSON.stringify(state.btnStatus))
  },
  changeCallInfo (state) {
    localStorage.setItem('call-info', JSON.stringify(state.callInfo))
  },
  changeDnis (state, payload) {
    state.callInfo.dnis = payload
  },
  changeBrandDnis (state, payload) {
    state.callInfo.brandDnis = payload
  },
  changeStartTime (state, payload) {
    state.callInfo.startTime = payload
  },
  changeEndTime (state, payload) {
    state.callInfo.endTime = payload
  },
  changeIncomingChannel (state, payload) {
    state.callInfo.incomingChannel = payload
  },
  changeServiceCode (state, payload) {
    state.callInfo.serviceCode = payload
  },
  changeIsClose (state, payload) {
    state.callInfo.isClose = payload
  },
  changeIsAgentClose (state, payload) {
    state.callInfo.isAgentClose = payload
  },
  changeIsSummaryCompleted (state, payload) {
    state.callInfo.isSummaryCompleted = payload
  },
  changeCallEvent (state, payload) {
    state.callInfo.callEvent = payload
  },
  changeDirection (state, payload) {
    state.callInfo.direction = payload
  },
  changeCallUserKey (state, payload) {
    if (payload.includes('anonymous') || payload === 'notdefined') {
      payload = uuidV4().replaceAll('-', '').substr(0, 12)
      state.callInfo.isAnonymous = true
    } else if (state.callInfo.isAnonymous) {
      state.callInfo.isAnonymous = false
    }
    state.callInfo.userKey = payload
  },
  changeTicketId (state, payload) {
    state.callInfo.ticketId = payload
  },
  changeRecordNo (state, payload) {
    state.callInfo.recordNo = payload
  },
  changeCallBackInfo (state, payload) {
    state.callInfo.callbackId = payload.callbackId
    state.callInfo.callbackType = payload.callbackType
  },
  changeIsOriginatedEnd (state, payload) {
    state.callInfo.isOriginatedEnd = payload
  },
  changeIsCleared (state, payload) {
    state.callInfo.isCleared = payload
  },
  changeTaskData (state, payload) {
    state.callInfo.taskData = payload
  },
  changeContactTypeId (state, payload) {
    state.callInfo.contactTypeId = payload
  },
  changeCallTagList (state, list) {
    state.callInfo.tagList = list
  },
  changeMemo (state, payload) {
    state.callInfo.memo = payload
  },
  changeTicketStatus (state, payload) {
    state.callInfo.ticketStatus = payload
  },
  changeCallEnd (state, isCallEnd) {
    state.callInfo.isCallEnd = isCallEnd
  },
  changeCallInfoByKey (key, value) {
    state.callInfo[key] = value
  },
  clearIsAnonymous (state) {
    state.callInfo.isAnonymous = false
  },
  CLEAR_CALL_STATUS (state) {
    localStorage.removeItem('call-info')
    localStorage.removeItem('btn-status')
    localStorage.removeItem('call-agent-status')
    window.sessionStorage.clear()
    mutations.clearCallInfo(state)
  },
  setChannelUniqueKey (state, payload) {
    state.channelUniqueKey = payload
  },
  setIsTransferCancel (state, payload) {
    state.isTransferCancel = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/call/callStatus.js